import { Box, Button } from '@factorialco/deprecated-design-system'
import {
  ProfileDeleteTeamMembershipDocument,
  ProfileEmployeeMembershipFragment,
  ProfilePageDocument,
  ProfileWorkDetailsTeamsDocument,
} from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  employeeId: string
  to: string
  teamMembership: ProfileEmployeeMembershipFragment
  canManageTeams: boolean
}

function Options({ employeeId, to, teamMembership, canManageTeams }: Props) {
  const [deleteTeamMembership] = useMutation(ProfileDeleteTeamMembershipDocument, {
    extractorFn: (data) => data.teamsMutations.deleteTeamsMembership,
    refetchQueries: [
      ProfilePageDocument,
      { query: ProfileWorkDetailsTeamsDocument, variables: { employeeId } },
    ],
    update: (cache) => {
      cache.modify({
        id: cache.identify({ __typename: 'EmployeesEmployee', id: employeeId }),
        fields: {
          memberships(existingMemberships = [], { readField }) {
            return existingMemberships.filter(
              (item: { __ref?: string }) => readField('id', item) !== teamMembership.id
            )
          },
        },
      })
      cache.evict({ id: `TeamsMembership:${teamMembership.id}` })
      cache.gc()
    },
  })

  const removeFromTeam = async () => {
    const result = await deleteTeamMembership({ variables: { id: teamMembership.id } })

    const handled = handleResult(result, (errors) => {
      if (errors) {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('profile.employee.teams.remove_from_team_error'),
        })
      }
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('profile.employee.teams.remove_from_team'),
      })
    }

    return handled
  }

  return (
    <Box flexDirection="row" gap="s12">
      {canManageTeams && (
        <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
          <PopoverMenu type="list">
            <PopoverMenu.Trigger>
              <Button.Decorative type="secondary" iconName="ellipsis" />
            </PopoverMenu.Trigger>
            <PopoverMenu.Content side="bottom" align="center">
              <PopoverMenu.TouchableOption
                title={i18n.t('teams.remove_from_team')}
                onClick={removeFromTeam}
                danger
              />
            </PopoverMenu.Content>
          </PopoverMenu>
        </Box>
      )}
      <Button.Router to={to} type="secondary" iconName="arrow-right" />
    </Box>
  )
}

export default Options
